import React from 'react';
import * as Styled from './textarea.styles';

const Textarea = React.forwardRef((props, ref) => (
    <Styled.Container>
        <Styled.Element ref={ref} {...props} autoComplete='off' />
    </Styled.Container>
));

export default Textarea;
